import { render, staticRenderFns } from "./dayOfWeek.vue?vue&type=template&id=10bafcb4&"
import script from "./dayOfWeek.vue?vue&type=script&lang=js&"
export * from "./dayOfWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports